import { create } from "zustand";

export const useDisputeModal = create((set) => ({
  files: [],
  isUploaded: false,
  isOpenInitiateDisputeModal: false,
  isOpenDisputeConfirmationModal: false,
  isOpenDisputePaymentModal: false,
  selectedRecord: [],
  isDisputePaymentSuccess: false,
  setFiles: (val) => set({ files: val }),
  setIsUploaded: (val) => set({ isUploaded: val }),
  setisOpenInitiateDisputeModal: (val) =>
    set({ isOpenInitiateDisputeModal: val }),
  setIsOpenDisputeConfirmationModal: (val) =>
    set({ isOpenDisputeConfirmationModal: val }),
  setIsOpenDisputePaymentModal: (val) =>
    set({ isOpenDisputePaymentModal: val }),
  setSelectedRecord: (val) => set({ selectedRecord: val }),
  setIsDisputePaymentSuccess: (val) => set({ isDisputePaymentSuccess: val }),
}));
